// Strings for the read-only header of a Loom lead. The wording is the same as the client view's
// header (client.ClientDetail.Status).
export default {
  Subtitles: {
    Created: 'Joined: #{value}',
    Updated: 'Updated: #{value}',
    Day: 'Day #{number}',
  },
  Metrics: {
    PrimaryContact: 'Primary Contact',
    ContactEmail: 'Contact Email',
    ContactPhone: 'Contact Phone',
    IntroCall: 'Intro call',
  },
  Menu: {
    Subtitles: {
      Stage: 'Stage',
      LeadQuality: 'Lead Quality',
    },
  },
};
